var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    staticClass: "confirm",
    on: { close: _vm.close },
    scopedSlots: _vm._u(
      [
        {
          key: "modal-header",
          fn: function() {
            return [_vm._t("modal-header")]
          },
          proxy: true
        },
        {
          key: "modal-body",
          fn: function() {
            return [_c("div", [_vm._t("modal-body")], 2)]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "div",
                [
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.cancel"),
                      type: "secondary"
                    },
                    on: { click: _vm.close }
                  }),
                  _vm._v(" "),
                  _c("CompassButton", {
                    attrs: { label: _vm.$t.__("common.actions.confirm") },
                    on: { click: _vm.confirm }
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }